import { styled } from '@mui/material/styles';

import { AppBar as MuiAppBar, Drawer as MuiDrawer } from '@mui/material';

const drawerWidth = 200;


export const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

export const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

export const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));


// Unlike AppBar above, `open` must reach the real MuiDrawer: for variant="temporary"
// MUI's own internal rendering (the Modal/Slide it shows on mobile) is driven by its
// `open` prop, not just by our custom CSS mixins below. Blocking it (as the official
// MUI "mini variant drawer" example does) silently breaks the mobile overlay: MuiDrawer
// always sees `open=undefined` and never renders anything. It only ever "worked" here
// because the permanent (desktop) variant doesn't consume `open` internally at all.
export const Drawer = styled(MuiDrawer)(
    ({ theme, open, variant }) => ({
        // variant="permanent" (desktop): the drawer's root is a real element in the
        // page's flex flow, so it needs its own width/flexShrink to dock properly and
        // to collapse to a thin icon rail when closed.
        ...(variant !== 'temporary' && {
            width: drawerWidth,
            flexShrink: 0,
            whiteSpace: 'nowrap',
            boxSizing: 'border-box',
            ...(open && {
                ...openedMixin(theme),
                '& .MuiDrawer-paper': openedMixin(theme),
            }),
            ...(!open && {
                ...closedMixin(theme),
                '& .MuiDrawer-paper': closedMixin(theme),
            }),
        }),
        // variant="temporary" (mobile): MUI renders the root as a full-viewport Modal,
        // not a flex sibling, so it must NOT be constrained to drawerWidth — only the
        // sliding paper inside it should be. There's no collapsed/rail state on mobile,
        // the drawer is either a full-width overlay or not rendered at all.
        ...(variant === 'temporary' && {
            '& .MuiDrawer-paper': {
                width: drawerWidth,
                boxSizing: 'border-box',
            },
        }),
    }),
);


export const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

